import Role from "./roles";

const APP_ENV = process.env.REACT_APP_ENV;
const APP_TARGET_ENV = process.env.REACT_APP_TARGET_ENV;

export const getGlobalKey = () => {
  let key = "global_feature_flags";
  if (APP_TARGET_ENV?.length > 0) {
    key = APP_TARGET_ENV + "_feature_flags";
  }

  switch (APP_ENV) {
    case "dev":
    case "staging":
      key += "_dev";
      break;

    default:
    case "prod":
      break;
  }

  return key;
};

export const coreFeatureFlag = {
  ASSET: true,
  CONTENT: true,
  SCREEN: true,
  SCREEN_GROUP: true,
  USER: true,
  USER_GROUP: true,
  SCHEDULE: true,
  ADVERTISEMENT: true,
  "SCHEDULE.COMMAND": false,
  "SCHEDULE.CONTENT": true,
  "SCHEDULE.CALENDAR": true,
  ANNOUNCEMENT: true,
  "LOG.AUDIT": true,
  "LOG.CONTENT": false,
  "SMRT.HIVESTACK": true,
  "SMRT.VISTAR": true,
  "BPLRT.EQUIPMENT": true,
  "BPLRT.SMP": true,
};

const featureFlagPermissionFilter = {
  SMRT_TRAIN: ["smrtLine", "smrtStation", "smrtTrainEvent"],
  BPLRT: ["equipment", "platform", "smpAnnouncement", "station", "track"],
};

export const excludedPermissionKeys = (features, role = "Basic") => {
  const excludedKeys = Object.entries(featureFlagPermissionFilter)
    ?.filter(([flag]) => features[flag] === false)
    ?.flatMap(([_, perms]) => perms);

  return role === Role.Eins ? [] : excludedKeys;
};
